<template>
  <div v-show='show'>
    <ejs-chart ref='refName' :id='id' style='display:block '  align='center' :title='title' :primaryXAxis='primaryXAxis' :primaryYAxis='primaryYAxis'
        :tooltip='tooltip' :chartArea='chartArea' v-bind:width='width2' v-bind:height='height2' :subTitle='subTitle'>
        <e-series-collection>
            <e-series :dataSource='seriesData' type='Line' xName='start_time' yName='kpi' :name='seriesName' width=2 :marker='marker'> </e-series>
        </e-series-collection>
    </ejs-chart>

</div>
</template>
<style>

</style>
<script>
import Vue from 'vue';
import { Browser } from '@syncfusion/ej2-base';
import { ChartPlugin, LineSeries, Legend, Tooltip, DateTime } from '@syncfusion/ej2-vue-charts';

export default Vue.extend({
  name: 'lineChart',
  props: ['chartData'],
  data() {
    return {
      id: 'id',
      primaryXAxis: {
        valueType: 'DateTime',
        labelFormat: 'y-MM-dd HH:mm:ss',
        intervalType: 'Auto', // Hours Minutes
        // interval:15,
        edgeLabelPlacement: 'Shift',
        majorGridLines: { width: 1 },
      },
      primaryYAxis: {
        valueType: 'Double',
        labelFormat: 'n', // keep four decimal places
        rangePadding: 'Round',
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 },
        interval:10,
        minimum: 0,
        maximum: 100,
      },
      chartArea: {
        border: {
          width: 0
        }
      },
      width: '500',
      height: '256',
      marker: {
        visible: true,
        height: 2,
        width: 2
      },
      tooltip: {
        enable: true,
        position: 'Bottom'
      },
      title: '',
      subTitle: '',
      seriesName: 'seriesName2',
      // position:'Bottom'
    };
  },
  provide: {
    chart: [LineSeries, Legend, Tooltip, DateTime]
  },
  mounted() {
  },
  methods: {
  },
  computed: {
    show() {
      if (this.id === 'id') {
        this.id = this.chartData.id;
      }
      return this.chartData.show;
    },
    width2() {
      let { width } = this;
      if (this.chartData.show) {
        width = this.chartData.width;
      }
      return width;
    },
    height2() {
      let { height } = this;
      if (this.chartData.show) {
        height = this.chartData.height;
      }
      return height;
    },
    seriesData() {
      if (this.chartData.seriesData.length > 0) {
        let cell = '';
        //console.log('this.chartData.seriesData[0].cell_id',this.chartData.seriesData[0].cell_id)
        if (this.chartData.seriesData[0].cell_id !== undefined) {
          cell = (this._i18n.locale === 'zh') ? (`小区${this.chartData.seriesData[0].cell_id}`) : (`cell${this.chartData.seriesData[0].cell_id}`);
          cell = `-${cell}`;
        }
        this.seriesName = (this._i18n.locale === 'zh') ? this.chartData.seriesData[0].kpiNameCn + cell : this.chartData.seriesData[0].kpiNameEn + cell;
      }
      return this.chartData.seriesData;
    },
  },
  watch: {
  }
});
</script>
